import authentication from './modules/authentication';
import users from './modules/users';
import countries from './modules/countries';
import medicalInstitutions from './modules/medicalInstitutions';
import hospitals from './modules/hospitals';
import roles from './modules/roles';
import medicalteam from './modules/medicalteam';
import trustedhub from './modules/trustedhub';
import medicaldevice from './modules/medicaldevice';
import patientmetadata from './modules/patientmetadata';
import nosessionhubs from './modules/nosessionhubs';
import verifiers from './modules/verifiers';
import doctormetadata from './modules/doctormetadata';
import nursemetadata from './modules/nursemetadata';
import publiclinks from './modules/publiclinks';
import metrics from './modules/metrics';
import socket from './modules/socket';
import notifications from './modules/notifications';
import treatmentplan from './modules/treatmentplan';
import appointments from './modules/appointments';
import appointmentrequests from './modules/appointmentrequests';
import googleAPI from './modules/geolocation';
import alerts from './modules/alerts';
import billings from './modules/billings';
import mentalhealth from './modules/mentalhealth';
import filterbar from './modules/filterbar';
import reportsRepo from './modules/reports';
import patientdiagnosis from './modules/patientdiagnosis';
import sysadmin from './modules/sysadmin';
import timetracking from './modules/timetracking';
import tablets from './modules/tablets';
import invoices from './modules/invoices';
import billingsauthorization from './modules/billingsauthorization';
import usersbillingsauthorization from './modules/usersbillingsauthorization';
import medicalnotecategory from './modules/medicalnotecategory';
import admin from './modules/admin';
import licenses from './modules/licenses';
import prescriptions from './modules/prescriptions';
import ccmRecords from './modules/ccmRecords';
import ccmDiagnoses from './modules/ccmDiagnoses';
import ccmConditions from './modules/ccmConditions';
import ccmMedicationEvents from './modules/ccmMedicationEvents';
import ccmMedicalNote from './modules/ccmMedicalNote';
import ccmCarePlans from './modules/ccmCarePlans';
import ccmTimeLogs from './modules/ccmTimeLogs';
import ccmVitalEntry from './modules/ccmVitalEntry';
import ccmObservation from './modules/ccmObservation';
import ccmAllergy from './modules/ccmAllergy';
import ccmBilling from './modules/ccmBilling';
import ccmAttachments from './modules/ccmAttachments';
import ccmConsentForms from './modules/ccmConsentForms';
import ccmVaccines from './modules/ccmVaccines';
import ccmImaging from './modules/ccmImaging';
import ccmLabs from './modules/ccmLabs';
import mapping from './modules/mapping';
import terra from './modules/terra';
import pcc from './modules/pcc';
import releaseNotes from './modules/releaseNotes';
import schedules from './modules/schedules';
import inventoryItemCatalogs from './modules/inventoryItemCatalogs';
import inventoryConsumableCatalogs from './modules/inventoryConsumableCatalogs';
import inventoryItems from './modules/inventoryItems';
import inventoryConsumables from './modules/inventoryConsumables';
import logLevels from './modules/logLevels';
import audits from './modules/audits';

export default {
	authentication,
	medicalnotecategory,
	billingsauthorization,
	users,
	countries,
	medicalInstitutions,
	mentalhealth,
	hospitals,
	admin,
	roles,
	medicalteam,
	trustedhub,
	medicaldevice,
	patientmetadata,
	nosessionhubs,
	verifiers,
	doctormetadata,
	nursemetadata,
	publiclinks,
	metrics,
	socket,
	notifications,
	treatmentplan,
	googleAPI,
	appointments,
	appointmentrequests,
	alerts,
	invoices,
	billings,
	filterbar,
	reportsRepo,
	patientdiagnosis,
	sysadmin,
	timetracking,
	usersbillingsauthorization,
	licenses,
	prescriptions,
	ccmRecords,
	ccmDiagnoses,
	ccmConditions,
	ccmCarePlans,
	ccmTimeLogs,
	ccmMedicationEvents,
	ccmVitalEntry,
	ccmMedicalNote,
	ccmObservation,
	ccmAllergy,
	ccmBilling,
	ccmAttachments,
	ccmConsentForms,
	ccmVaccines,
	ccmImaging,
	ccmLabs,
	tablets,
	mapping,
	pcc,
	terra,
	releaseNotes,
	schedules,
	inventoryItemCatalogs,
	inventoryConsumableCatalogs,
	inventoryItems,
	inventoryConsumables,
	logLevels,
	audits,
};
